import { faDownload, faHome, faSearch, faTv } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Img from "react-cool-img";
import { Link } from "react-router-dom";
import "./styles/AppBar.scss";

const AppBar = () => {
    const [currentButton, setCurrentButton] = useState(0);

    return (
        <div className="app-bar-container bg-white">
            <div className="user-avatar">
                <Link to="/userprofile/:userId">
                    <Img src="https://www.ipwatchdog.com/wp-content/uploads/2015/12/donald-trump-300.jpg" className="loading-image" />
                </Link>
            </div>
            <div className="user-controls">
                <div className="control-item">
                    <Link to="/">
                        <FontAwesomeIcon icon={faHome} size="lg"
                            onClick={() => {
                                setCurrentButton(0);
                                console.log(currentButton);
                            }}
                            className={currentButton == 0 ? "text-primary control-icon" : ""}
                        />
                        <p className="control-name">Home</p>
                    </Link>
                </div>
                <div className="control-item">
                    <FontAwesomeIcon icon={faSearch} size="lg"
                        onClick={() => {
                            setCurrentButton(1);
                            console.log(currentButton);
                        }}
                        className={currentButton == 1 ? "text-primary control-icon" : ""}
                    />
                    <p className="control-name">Search</p>
                </div>
                <div className="control-item">
                    <Link to="/movies">
                        <FontAwesomeIcon icon={faTv} size="lg"
                            onClick={() => {
                                setCurrentButton(2);
                                console.log(currentButton);
                            }}
                            className={currentButton == 2 ? "text-primary control-icon" : ""}
                        />
                        <p className="control-name">Watch</p>
                    </Link>
                </div>
                <div className="control-item">
                    <FontAwesomeIcon icon={faDownload} size="lg"
                        onClick={() => {
                            setCurrentButton(3);
                            console.log(currentButton);
                        }}
                        className={currentButton == 3 ? "text-primary control-icon" : ""}
                    />
                    <p className="control-name">Downloads</p>
                </div>
            </div>
        </div>
    );
};

export default AppBar;
